import Button from "@mui/material/Button";
import * as React from 'react';
import { useMemo } from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import { Link } from "react-router-dom";
import {
	access_rights,
	access_roles,
	access_user,
	access_parameters, access_projects, access_registrations, access_reports, access_skills, access_rates,
} from "../../../../helpers/rights";
import { ROUTE_PAGE_RATES_INDEX } from "../../../../modules/rates/routes/routes";
import {
	ROUTE_PAGE_MOBILE_REGISTRATIONS_INDEX,
	ROUTE_PAGE_NEW_REGISTRATION,
	ROUTE_PAGE_REGISTRATIONS_INDEX
} from "../../../../modules/registrations/routes/routes";
import { ROUTE_PAGE_PARAMETERS_INDEX } from "../../../../modules/parameters/routes/routes";
import { ROUTE_PAGE_PROJECTS_INDEX } from "../../../../modules/projects/routes/routes";
import { ROUTE_PAGE_REPORTS } from "../../../../modules/reports/routes/routes";
import { ROUTE_PAGE_RIGHTS_INDEX } from "../../../../modules/rights/routes/routes";
import { ROUTE_PAGE_SPECIALTIES_INDEX } from "../../../../modules/specialties/routes/routes";
import { ROUTE_PAGE_USERS_EDIT, ROUTE_PAGE_USERS_INDEX } from "../../../../modules/users/routes/routes";
import { ROUTE_PAGE_SECURITY_ROLES_INDEX } from "../../../../modules/usersSecurityRoles/routes/routes";
import Logo from "../../../custom/general/logo/logo";
import { getRouteUrl } from "../../../../helpers/routing/getRouteUrl";
import { useTranslation } from "react-i18next";
import { NAVIGATION } from "../../../../locales/components/namespaces";
import {
	ROUTE_PAGE_HOME
} from "../../../../routers/routes";
import LanguageSelect from "../../languageSelect/languageSelect";
import AccountMenu from "../../accountMenu/accountMenu";
import AppDrawer from "../appDrawer/appDrawer";
import MainMenu from "../mainMenu/mainMenu";
import {useMediaQuery, useTheme} from "@mui/material";

export const menuStyle = {
	color: '#224B69',
	fontWeight: 'bold',
	'&:hover': {
		bgcolor: 'secondary.lighter',
		color: 'primary.darker'
	},
}

export const menuIconStyle = {
	color: '#224B69',
	'&:hover': {
		backgroundColor: '#224B69',
		color: '#FFFFFF',
	},
}

const Header = (props) => {
	const { t } = useTranslation(NAVIGATION)
	const [mobileOpen, setMobileOpen] = React.useState(false);
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
	const handleDrawerToggle = () => {
		setMobileOpen((prevState) => !prevState);
	};
	const navItems = useMemo(() => [
		{
			id: 1,
			url: getRouteUrl(ROUTE_PAGE_HOME),
			title: t("Home"),
			// permissions: [view_parent_dashboard, view_contractor_dashboard]
		},
		// {
		// 	id: 2,
		// 	url: getRouteUrl(ROUTE_PAGE_REGISTRATIONS_INDEX),
		// 	title: t("Registration History"),
		// 	permissions: [access_registrations]
		// },
		{
			id: 2,
			url: getRouteUrl(ROUTE_PAGE_MOBILE_REGISTRATIONS_INDEX),
			title: t("Registration History"),
			permissions: [access_registrations]
		},
		{
			id: 3,
			url: getRouteUrl(ROUTE_PAGE_NEW_REGISTRATION),
			title: t("New Registration"),
			permissions: [access_registrations]
		},
		{
			id: 4,
			url: getRouteUrl(ROUTE_PAGE_PROJECTS_INDEX),
			title: t("Projects"),
			permissions: [access_projects]
		},
		{
			id: 5,
			url: getRouteUrl(ROUTE_PAGE_REPORTS, {}, {section: "projects"}),
			title: t("Reports"),
			permissions: [access_reports]
		},
		{
			id: 6,
			url: getRouteUrl(ROUTE_PAGE_SPECIALTIES_INDEX),
			title: t("Specialties"),
			permissions: [access_skills]
		},
		// {
		// 	id: 6,
		// 	url: getRouteUrl(ROUTE_PAGE_PARAMETERS_INDEX),
		// 	title: t("Costs"),
		// 	permissions: [access_parameters]
		// },
		{
			id: 7,
			url: getRouteUrl(ROUTE_PAGE_USERS_INDEX,{role:1}),
			title: t("Workers"),
			permissions: [access_user]
		},
		{
			id: 8,
			url: getRouteUrl(ROUTE_PAGE_USERS_INDEX,{role:0}),
			title: t("Users"),
			permissions: [access_user]
		},
		{
			id: 9,
			url: getRouteUrl(ROUTE_PAGE_RATES_INDEX),
			title: t("Rates"),
			permissions: [access_rates]
		},
		{
			id: 10,
			url: getRouteUrl(ROUTE_PAGE_SECURITY_ROLES_INDEX),
			title: t("Roles"),
			permissions: [access_roles]
		},
		{
			id: 11,
			url: getRouteUrl(ROUTE_PAGE_RIGHTS_INDEX),
			title: t("Rights"),
			permissions: [access_rights]
		},
		


		
	], [t])
	
	return (
		<Box>
			<AppBar
				component="nav"
				elevation={0}
				sx={{
					bgcolor: '#FFFFFF',
					minHeight: 73,
					justifyContent: 'center',
					// paddingTop: 'env(safe-area-inset-top)',
					// paddingLeft: 'env(safe-area-inset-left)',
					// paddingRight: 'env(safe-area-inset-right)',
					boxSizing: 'border-box',
				}}
			>
				<Toolbar
					variant={'dense'}
					sx={{ justifyContent: 'space-between', minHeight: 'calc(56px + env(safe-area-inset-top))',mt:3}}
				>
					
					<Box>
						<IconButton
							color="inherit"
							aria-label="open drawer"
							edge="start"
							onClick={handleDrawerToggle}
							sx={{mr: 'auto', display: {md: 'none'}}}
						>
							<MenuIcon color={'primary'}/>
						</IconButton>
						<Box
							sx={{
								display: {xs: 'none', sm: 'none', md: 'block'},
								marginRight: 1
							}}
						>
							<Logo
								auth
								style={{
									maxWidth: '130px',
									minHeight: '50px'
								}}
							/>
						</Box>
					</Box>
					<Box>
						<MainMenu navItems={navItems}/>
					</Box>
					<Box sx={{ display: 'flex', alignItems: 'center' }}>
						<LanguageSelect/>
						<AccountMenu/>
					</Box>
				</Toolbar>
			</AppBar>
			<Toolbar/>
			<AppDrawer
				mobileOpen={mobileOpen}
				handleDrawerToggle={handleDrawerToggle}
				navItems={navItems}
			/>
		</Box>
	);
}

export default Header;
